<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M3 5v22a2 2 0 002 2h22a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2zm24 0v4H5V5zM5 27V11h22v16z"/><path d="M23 12.5H9a.5.5 0 000 1h14a.5.5 0 000-1zM14 7.5h4a.5.5 0 000-1h-4a.5.5 0 000 1z"/><circle cx="11" cy="7" r=".5"/><circle cx="8" cy="7" r=".5"/><circle cx="24" cy="7" r=".5"/><circle cx="21" cy="7" r=".5"/><path d="M9.5 24.5h13a1 1 0 001-1V16a1 1 0 00-1-1h-13a1 1 0 00-1 1v7.5a1 1 0 001 1zm0-8.5h13v7.5h-13z"/></svg>